"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.styles = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popper = _interopRequireDefault(require("./../../Popper"));

var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));

var _MoreVertical = _interopRequireDefault(require("@ellucian/ds-icons/lib/MoreVertical"));

var _decorateActionMenuChildren = _interopRequireDefault(require("./decorateActionMenuChildren"));

var _styles = _interopRequireDefault(require("./../../styles"));

var _tokens = require("./../../styles/tokens");

var styles = function styles(theme) {
  return {
    paper: {
      padding: 0,
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400]
    },
    menuList: {
      maxWidth: '18.750rem',
      borderRadius: "" + _tokens.borderRadiusXSmall
    }
  };
};
/**
 * PopperWrapper
 */


exports.styles = styles;

var PopperWrapper = function PopperWrapper(props) {
  var classes = props.classes,
      placement = props.placement,
      id = props.id,
      edsContext = props.edsContext,
      PopperProps = props.PopperProps,
      PaperProps = props.PaperProps,
      open = props.open,
      handleClose = props.handleClose,
      buttonRef = props.buttonRef,
      children = props.children;
  var popperPlacement = placement ? placement : edsContext.dir === 'rtl' ? 'bottom-start' : 'bottom-end';
  var PopperPropsProps = Object.assign({}, PopperProps);
  var offset = 20; // Bring popper closer to icon
  // TODO: Do this with lodash or ES6 way.

  if (PopperPropsProps.modifiers) {
    PopperPropsProps.modifiers.offset = offset;
  } else {
    PopperPropsProps.modifiers = {
      offset: offset
    };
  }

  var onKeyDown = function onKeyDown(event) {
    var key = event.key;

    if (key === 'Escape' || key === 'Tab') {
      event.preventDefault();
      handleClose();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Popper.default, (0, _extends2.default)({
    arrow: true,
    anchorEl: buttonRef.current,
    open: open,
    placement: popperPlacement,
    onClickAway: handleClose,
    className: "eds-actionmenu-popper",
    PaperProps: (0, _extends2.default)({
      'aria-live': 'off',
      classes: {
        root: classes.paper
      },
      elevation: 1
    }, PaperProps)
  }, PopperPropsProps, {
    onKeyDown: onKeyDown,
    transition: false
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    id: id,
    className: classes.menuList,
    autoFocusItem: open
  }, children && (0, _decorateActionMenuChildren.default)(children, handleClose))));
};

PopperWrapper.propTypes = {
  children: _propTypes.default.node.isRequired,
  buttonRef: _propTypes.default.object,
  open: _propTypes.default.bool,
  handleClose: _propTypes.default.func,
  classes: _propTypes.default.object,
  className: _propTypes.default.string,
  edsContext: _propTypes.default.object,
  id: _propTypes.default.string,
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start']),
  PaperProps: _propTypes.default.object,
  PopperProps: _propTypes.default.object
};
PopperWrapper.defaultProps = {
  initialOpenOverride: false,
  icon: /*#__PURE__*/_react.default.createElement(_MoreVertical.default, null)
};

var _default = (0, _styles.default)(styles)(PopperWrapper);

exports.default = _default;